import { useMutation, useQueryClient } from '@tanstack/react-query';
import { postCropFavorite } from '../../../../api/crop-trends/mutations/postCropFavorite';

export const usePostCropFavorite = () => {
  const queryClient = useQueryClient();

  return useMutation(postCropFavorite, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['crop-favorite'] });
      queryClient.invalidateQueries({ queryKey: ['favorite-crop-prices'] });
    },
  });
};
